export default "__VITE_ASSET__CIpJB1t8__"